// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#transport {
  position: fixed;
  top: 0;
  background: #333;
  height: 36px;
  width: 100%;
  z-index: 100;
}

.transport {
  display: flex;
  flex-direction: row;
  background: #333;
  padding: 2px 0;
}

.transport .item {
  display: flex;
  margin: 0 5px;
}

.transport .item button {
  width: 32px;
  height: 32px;
}

.transport .item .record {
  color: red;
}

#master-volume {
  min-width: 250px;
  background-color: #222;
  border-color: black;
  box-shadow: inset 1px -1px 1px #666;
}

#master-volume.ui-slider {
  background: #222;
}

#master-volume .ui-slider-range {
  background: #04AEF7;
  background: -moz-linear-gradient(top, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

#master-volume .ui-slider-handle {
  border-radius: 50%;
  background: -moz-linear-gradient(top, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  border-color: black;
}

#master-volume .ui-slider-handle:focus {
  outline: none;
}

.volume-icon {
  color: #888;
  font-size: 16px;
  padding: 0 2px;
}

input#songname {
  color: #888;
  font-size: 16px;
  padding: 0 2px;
  width: 250px;
  text-align: left;
}

#record-progress {
  width: 100%;
  margin: 5px;
}

#record-seq {
  margin: 5px;
}

.fps {
  color: #888;
  font-size: 12px;
}

#dialog .controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#url-input {
  width: 100%;
  background-color: #444;
}
`, "",{"version":3,"sources":["webpack://./src/components/transport/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oRAAoR,EAAE,aAAa;EACnS,uRAAuR,EAAE,4BAA4B;EACrT,qRAAqR,EAAE,qDAAqD;AAC9U;;AAEA;EACE,kBAAkB;EAClB,sHAAsH,EAAE,aAAa;EACrI,yHAAyH,EAAE,4BAA4B;EACvJ,uHAAuH,EAAE,qDAAqD;EAC9K,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["#transport {\n  position: fixed;\n  top: 0;\n  background: #333;\n  height: 36px;\n  width: 100%;\n  z-index: 100;\n}\n\n.transport {\n  display: flex;\n  flex-direction: row;\n  background: #333;\n  padding: 2px 0;\n}\n\n.transport .item {\n  display: flex;\n  margin: 0 5px;\n}\n\n.transport .item button {\n  width: 32px;\n  height: 32px;\n}\n\n.transport .item .record {\n  color: red;\n}\n\n#master-volume {\n  min-width: 250px;\n  background-color: #222;\n  border-color: black;\n  box-shadow: inset 1px -1px 1px #666;\n}\n\n#master-volume.ui-slider {\n  background: #222;\n}\n\n#master-volume .ui-slider-range {\n  background: #04AEF7;\n  background: -moz-linear-gradient(top, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* FF3.6-15 */\n  background: -webkit-linear-gradient(top, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* Chrome10-25,Safari5.1-6 */\n  background: linear-gradient(to bottom, rgba(30, 87, 153, 0) 0%, rgba(30, 87, 153, 0.8) 15%, rgba(30, 87, 153, 1) 19%, rgba(30, 87, 153, 1) 20%, rgba(41, 137, 216, 1) 50%, rgba(30, 87, 153, 1) 80%, rgba(30, 87, 153, 1) 81%, rgba(30, 87, 153, 0.8) 85%, rgba(30, 87, 153, 0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n\n#master-volume .ui-slider-handle {\n  border-radius: 50%;\n  background: -moz-linear-gradient(top, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* FF3.6-15 */\n  background: -webkit-linear-gradient(top, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* Chrome10-25,Safari5.1-6 */\n  background: linear-gradient(to bottom, rgba(181, 189, 200, 1) 0%, rgba(130, 140, 149, 1) 36%, rgba(40, 52, 59, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n  border-color: black;\n}\n\n#master-volume .ui-slider-handle:focus {\n  outline: none;\n}\n\n.volume-icon {\n  color: #888;\n  font-size: 16px;\n  padding: 0 2px;\n}\n\ninput#songname {\n  color: #888;\n  font-size: 16px;\n  padding: 0 2px;\n  width: 250px;\n  text-align: left;\n}\n\n#record-progress {\n  width: 100%;\n  margin: 5px;\n}\n\n#record-seq {\n  margin: 5px;\n}\n\n.fps {\n  color: #888;\n  font-size: 12px;\n}\n\n#dialog .controls {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n#url-input {\n  width: 100%;\n  background-color: #444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
